import {Employee} from '../../../core/entities/employee'
import {Sort} from '../../../core/entities/sort'

const sortEmployees = ({
    ids,
    map,
    sortBy,
}: {
    ids: number[]
    map: Record<number, Employee>
    sortBy: Sort
}) => {
    const sortedIds = [...ids]
    switch (sortBy) {
        case 'name':
            return sortedIds.sort((a, b) => {
                const nameA = (
                    map[a].firstName + map[a].lastName
                ).toLocaleLowerCase()
                const nameB = (
                    map[b].firstName + map[b].lastName
                ).toLocaleLowerCase()
                if (nameA < nameB) {
                    return -1
                }
                if (nameA > nameB) {
                    return 1
                }
                return 0
            })
        case 'rating':
            return sortedIds
        case 'tip':
            return sortedIds
        case 'experience':
            return sortedIds
        default:
            return sortedIds
    }
}

export default sortEmployees
